import React from 'react';
import PageLayout from '../../components/common/PageLayout';
import './WorkAreas.css';

/**
 * Çalışma Alanlarımız (Practice Areas) Sayfası
 * Karadaş Hukuk Bürosu
 *
 * 6 Ana Çalışma Alanı:
 * 1. Ceza Hukuku
 * 2. Aile Hukuku
 * 3. İş ve Değerli Belge Hukuku
 * 4. İcra ve İflas Hukuku
 * 5. İdare Hukuku
 * 6. Ticaret Hukuku
 */
const WorkAreas: React.FC = () => {
  const practiceAreas = [
    {
      id: 1,
      icon: 'bi-bank2',
      title: 'Ceza Hukuku',
      description:
        'Suç ve kabahatlerde savunma, soruşturma ve kovuşturma süreçlerinde müvekkil haklarının korunması, etkin temsil ve profesyonel hukuki danışmanlık hizmeti sunuyoruz.',
    },
    {
      id: 2,
      icon: 'bi-people',
      title: 'Aile Hukuku',
      description:
        'Boşanma, velayet, nafaka, mal paylaşımı, evlat edinme ve aile içi şiddet konularında hassas ve güvenilir hukuki destek ile yanınızdayız.',
    },
    {
      id: 3,
      icon: 'bi-briefcase',
      title: 'İş ve Değerli Belge Hukuku',
      description:
        'İşçi ve işveren arasındaki uyuşmazlıklar, kıdem tazminatı, işe iade davaları, çek, senet ve bono takibi gibi konularda uzman hukuki destek sağlıyoruz.',
    },
    {
      id: 4,
      icon: 'bi-file-earmark-text',
      title: 'İcra ve İflas Hukuku',
      description:
        'Alacak tahsili, haciz işlemleri, ihtiyati tedbir, icra takipleri ve iflas süreçlerinde kapsamlı hukuki destek ile müvekkillerimizin haklarını koruyoruz.',
    },
    {
      id: 5,
      icon: 'bi-building',
      title: 'İdare Hukuku',
      description:
        'Kamu kurumları, belediyeler ve idari makamlarla ilgili süreçlerde, idari işlemlerin iptali, tam yargı davaları ve idari uyuşmazlıklarda hizmet veriyoruz.',
    },
    {
      id: 6,
      icon: 'bi-graph-up-arrow',
      title: 'Ticaret Hukuku',
      description:
        'Şirket kurulumu, birleşme ve devir işlemleri, ticari sözleşmeler, ortaklık anlaşmazlıkları ve ticari davalar konusunda profesyonel danışmanlık sunuyoruz.',
    },
  ];

  return (
    <PageLayout kind="work" title="Çalışma Alanlarımız">

      {/* PRACTICE AREAS GRID */}
      <section className="work-areas-grid-section">
        <div className="work-areas-container">
          {/* Subtitle */}
          <p className="work-areas-subtitle">
            HUKUKİ İHTİYAÇLARINIZA YÖNELİK, ALANINDA UZMAN EKİBİMİZLE PROFESYONEL VE SONUÇ ODAKLI ÇÖZÜMLER SUNUYORUZ.
          </p>

          <div className="practice-areas-grid">
            {practiceAreas.map((area) => (
              <div key={area.id} className="practice-area-card">
                {/* Icon */}
                <div className="practice-area-icon">
                  <i className={`bi ${area.icon}`}></i>
                </div>

                {/* Content */}
                <div className="practice-area-content">
                  <h3 className="practice-area-title">{area.title}</h3>
                  <p className="practice-area-description">{area.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="work-areas-cta">
        <div className="work-areas-container">
          <div className="work-areas-cta-content">
            <h2 className="work-areas-cta-title">Hangi Alanda Desteğe İhtiyacınız Var?</h2>
            <p className="work-areas-cta-text">
              Tüm hukuki süreçlerinizde yanınızdayız. İletişime geçin, size özel
              çözümler üretelim.
            </p>
            <a href="mailto:info@karadashukuk.com" className="work-areas-cta-button">
              <i className="bi bi-envelope"></i>
              İletişime Geçin
            </a>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default WorkAreas;
